import { Component, Input, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import {
    selectProfileIdentityName,
    selectProfileLogo,
    selectProfileReady,
    selectProfileSquareLogo
} from '../../../store/profile/profile.state';
import { NgClass, AsyncPipe } from '@angular/common';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-profile-logo',
    templateUrl: './profile-logo.component.html',
    styleUrls: ['./profile-logo.component.scss'],
    imports: [ NgClass, AsyncPipe ]
})
export class ProfileLogoComponent implements OnInit {

  constructor(private store: Store<AppState>) { }

  @Input()
  public small = false;

  @Input()
  public rotated = true;

  @Input()
  public full = false;

  profileReady$: Observable<boolean> = this.store.select(selectProfileReady);
  profileLogo$: Observable<string|null> = this.store.select(selectProfileLogo);
  profileSquareLogo$: Observable<string|null> = this.store.select(selectProfileSquareLogo);
  profileIdentityName$: Observable<string|null> = this.store.select(selectProfileIdentityName);

  rotate$: Observable<boolean> = this.profileSquareLogo$.pipe(
      map((logo) => this.small && logo === null)
  );
  url$ = combineLatest([this.profileLogo$, this.profileSquareLogo$]).pipe(
      map(([wide, square]) => this.small ? (square ? square : wide) : wide)
  );

  ngOnInit(): void {
  }

}
